import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatDate(dateString) {
  if (!dateString) return '-';
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
}

export function formatDateWithTimezone(dateString) {
  if (!dateString) return '-';
  const date = new Date(dateString);
  
  // Get timezone abbreviation
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const timeZoneAbbr = date.toLocaleTimeString('en-US', { timeZoneName: 'short' }).split(' ').pop();
  
  const formatted = date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
  
  return `${formatted} ${timeZoneAbbr}`;
}

export function formatRelativeTime(dateString) {
  if (!dateString) return '-';
  const date = new Date(dateString);
  const now = new Date();
  const diffMs = now - date;
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);
  
  if (diffMins < 1) return 'Just now';
  if (diffMins < 60) return `${diffMins}m ago`;
  if (diffHours < 24) return `${diffHours}h ago`;
  if (diffDays < 7) return `${diffDays}d ago`;
  return formatDate(dateString);
}

export function getStatusColor(status) {
  const colors = {
    new: 'bg-blue-100 text-blue-800 border-blue-200',
    in_review: 'bg-blue-100 text-blue-800 border-blue-200',
    more_info: 'bg-amber-100 text-amber-800 border-amber-200',
    approved: 'bg-emerald-100 text-emerald-800 border-emerald-200',
    rejected: 'bg-red-100 text-red-800 border-red-200',
    escalated: 'bg-purple-100 text-purple-800 border-purple-200',
    fraud_flagged: 'bg-orange-100 text-orange-800 border-orange-200'
  };
  return colors[status] || 'bg-gray-100 text-gray-800 border-gray-200';
}

export function getRiskBandColor(riskBand) {
  const colors = {
    low: 'bg-emerald-100 text-emerald-800',
    medium: 'bg-amber-100 text-amber-800',
    high: 'bg-orange-100 text-orange-800',
    critical: 'bg-red-100 text-red-800'
  };
  return colors[riskBand] || 'bg-gray-100 text-gray-800';
}

export function getPriorityColor(priority) {
  const colors = {
    normal: 'bg-slate-100 text-slate-700',
    high: 'bg-amber-100 text-amber-800',
    vip: 'bg-purple-100 text-purple-800'
  };
  return colors[priority] || 'bg-slate-100 text-slate-700';
}

export function truncateText(text, maxLength = 50) {
  if (!text) return '';
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength) + '...';
}
